import { render } from "./BoardingState.vue?vue&type=template&id=4cf11186&scoped=true"
import script from "./BoardingState.vue?vue&type=script&lang=js"
export * from "./BoardingState.vue?vue&type=script&lang=js"

import "./BoardingState.vue?vue&type=style&index=0&id=4cf11186&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf11186"]])

export default __exports__